const homeRoutePath = '/home';
const adminConsoleRoutePath = '/admin-console';
export const invydioPath = '/invydio-session';
export const appPermissionPath = '/app-permissions';
export const thankYouPagePath = '/thank-you-page';

const appRoutes = {
  /** User access */
  Login: '/',
  SetContext: '/set-context',
  FirstAccess: '/first-access',
  RetrieveCredentials: '/retrieve-credentials',
  RetrieveUsername: '/retrieve-username',
  RetrieveUserType: '/retrieve-user-type',
  RetrieveUsernameMultipleMatch: '/retrieve-username-multiple-match',
  RetrievePassword: '/retrieve-password',
  UserRegistration: '/user-registration',
  InsertDataUserRegistration: '/insert-data-user-registration',
  InformativeUserRegistration: '/informative-user-registration',
  InformativeUserLogin: '/informative-user-login',
  WelcomeUserRegistration: '/welcome-user-registration',
  EmailVerificationUserRegistration: '/email-verification-user-registration',
  InsertEmailUserRegistration: '/insert-email-user-registration',
  PhoneNumberVerificationUserRegistration:
    '/phone-number-verification-user-registration',
  InsertPhoneNumberUserRegistration: '/insert-phone-number-user-registration',
  InsertSecondaryPhoneNumberUserRegistration:
    '/insert-secondary-phone-number-user-registration',
  InsertFiscalCodeUserRegistration: '/insert-fiscal-code-user-registration',
  SignatureAreaUserRegistration: '/user-registration-signature-area',
  UnlockUserRequest: '/unlock-user-request',
  UnlockUserInsertUsername: '/unlock-user-insert-username',
  ReferralCode: '/referral-code',
  ThankYouPage: '/thank-you-page',
  CourtesyPage: '/courtesy-page',
  FinalizeOnboarding: '/finalize-onboarding',
  SetPassword: '/set-password',

  /** Home */
  HomeSection: homeRoutePath,
  Dashboard: `${homeRoutePath}/dashboard`,
  Wallet: `${homeRoutePath}/wallet`,
  WalletErDetail: `${homeRoutePath}/wallet/er/detail`,
  WalletEr: `${homeRoutePath}/wallet/er`,
  ViewReDetail: `${homeRoutePath}/wallet/er/view-detail`,
  Others: `${homeRoutePath}/others`,
  Sign: `${homeRoutePath}/sign`,
  Documents: `${homeRoutePath}/documents`,
  ForYou: `${homeRoutePath}/for-you`,
  News: `${homeRoutePath}/news`,
  ProfilePage: `${homeRoutePath}/profile-page`,
  FilterPage: `${homeRoutePath}/filter-page`,
  Faqs: `${homeRoutePath}/faqs`,
  DetailPositionListPage: `${homeRoutePath}/detail-position-list`,
  DetailPerformancePage: `${homeRoutePath}/detail-performance`,
  DetailTransactionsPage: `${homeRoutePath}/detail-transactions`,
  DetailUnderlyingPage: `${homeRoutePath}/detail-underlying`,
  MifidSurveyPage: `${homeRoutePath}/mifid-survey-page`,
  AmlFatcaCrsSurveyPage: `${homeRoutePath}/aml-fatca-crs-survey-page`,

  /** Admin console */
  AdminConsoleSection: adminConsoleRoutePath,
  CustomerService: `${adminConsoleRoutePath}/customer-service`,

  /** External */
  PrevinetPage: '/previnet',
  /** External */
  AzimutLife: '/azimut-life',
  AppPermissionPath: appPermissionPath,
  AppPermission: `${appPermissionPath}/:workflowName/:sessionId/:exitStatus`,
  InvydioEmbeddedSession: invydioPath,
  InvydioMobile: `${invydioPath}/:workflowName/:sessionId`,

  /** Errors */
  NotFound: 'not-found',

  /** Sign */
  SignRoomPage: `${homeRoutePath}/sign-room-page`,
  SignBackFromNamirial: `${homeRoutePath}/sign/back-from-namirial`,
  DocumentContent: `${homeRoutePath}/document-content`,

  /** Files viewer */
  PdfViewer: '/view-pdf',

  /** Web collaboration */
  CreateRoom: '/create-room',
  Room: '/room/:roomID',
  /** External */
  Openid: '/sso_login',
  IosMarketplace: '/ios-marketplace/:token',

  /** Maintenance */
  Maintenance: 'maintenance',
  ForceUpdate: '/forceUpdate',
};

export default appRoutes;
